import { render, staticRenderFns } from "./regional_authority.vue?vue&type=template&id=5368837e&scoped=true&"
import script from "./regional_authority.vue?vue&type=script&lang=js&"
export * from "./regional_authority.vue?vue&type=script&lang=js&"
import style0 from "./regional_authority.vue?vue&type=style&index=0&id=5368837e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5368837e",
  null
  
)

export default component.exports